/*
|-------------------------------------------------------------------------------
| VUEX modules/truckRunnings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import TruckRunningScheduleAPI from '../api/truckRunningSchedule.js';

export const truckRunningSchedules = {
    state: {
        truckRunningSchedules: [],
        truckRunningSchedulesLoadStatus: 0,

        truckRunningScheduleDeleteStatus: 0,

        truckRunningScheduleUpdateStatus: 0,

        truckRunningScheduleAddStatus: 0,
    },

    actions: {
        loadTruckRunningSchedules ( { commit } ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningSchedulesLoadStatus', 1 );

                TruckRunningScheduleAPI.get()
                    .then( function( response ){
                        commit( 'setTruckRunningSchedules', response.data.data );
                        commit( 'setTruckRunningSchedulesLoadStatus', 2 );
                        resolve();
                    })
                    .catch( error => {
                        console.log(error);
                        commit( 'setTruckRunningSchedules', [] );
                        commit( 'setTruckRunningSchedulesLoadStatus', 3 );
                        reject();
                    });
            });
        },
        deleteTruckRunningSchedule ( { commit, dispatch }, scheduleId ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningScheduleDeleteStatus', 1 );

                TruckRunningScheduleAPI.delete(scheduleId)
                    .then( function( response ){
                        commit( 'setTruckRunningScheduleDeleteStatus', 2 );
                        dispatch( 'loadTruckRunningSchedules');
                        resolve();
                    })
                    .catch( function(){
                        commit( 'setTruckRunningScheduleDeleteStatus', 3 );
                        reject();
                    });
            });
        },
        updateTruckRunningSchedule ( { commit, dispatch }, data ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningScheduleUpdateStatus', 1 );

                TruckRunningScheduleAPI.put( data )
                    .then( function( response ){
                        commit( 'setTruckRunningScheduleUpdateStatus', 2 );
                        dispatch( 'loadTruckRunningSchedules');
                        resolve();
                    })
                    .catch( function(){
                        commit( 'setTruckRunningScheduleUpdateStatus', 3 );
                        reject();
                    });
            });
        },
        addTruckRunningSchedule ( { commit, dispatch }, data ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningScheduleAddStatus', 1 );

                TruckRunningScheduleAPI.post( data )
                    .then( function( response ){
                        commit( 'setTruckRunningScheduleAddStatus', 2 );
                        dispatch( 'loadTruckRunningSchedules');
                        resolve();
                    })
                    .catch( function(){
                        commit( 'setTruckRunningScheduleAddStatus', 3 );
                        reject();
                    });
            });
        },
    },

    mutations: {
        setTruckRunningSchedules( state, rawSchedules ){
            state.truckRunningSchedules = rawSchedules.map(rawSchedule => mapToSchedule(rawSchedule));
        },
        setTruckRunningSchedulesLoadStatus( state, status ){
            state.truckRunningSchedulesLoadStatus = status;
        },
        setTruckRunningScheduleDeleteStatus( state, status ){
            state.truckRunningScheduleDeleteStatus = status;
        },
        setTruckRunningScheduleAddStatus( state, status ){
            state.truckRunningScheduleAddStatus = status;
        },
        setTruckRunningScheduleUpdateStatus( state, status ){
            state.truckRunningScheduleUpdateStatus = status;
        },
    },

    getters: {
        getTruckRunningSchedulesLoadStatus( state ){
            return state.truckRunningSchedulesLoadStatus;
        },
        getTruckRunningSchedules( state ){
            return state.truckRunningSchedules;
        },
        getTruckRunningScheduleUpdateStatus( state ){
            return state.truckRunningScheduleUpdateStatus;
        },
        getTruckRunningScheduleDeleteStatus( state ){
            return state.truckRunningScheduleDeleteStatus;
        },
        getTruckRunningScheduleAddStatus( state ){
            return state.truckRunningScheduleAddStatus;
        },
    },
};

/**
 * Helpers
 */
function mapToSchedule(resource) {
    let staAbb = resource.sta;
    if (resource.sta_add_days > 0) {
        staAbb = resource.sta + '(+' + resource.sta_add_days + ')';
    }
    let trucksAbb = resource.trucks.length + ' Trucks';
    resource.trucks.forEach(truck => {
        trucksAbb += ' ' + truck.plate;
    });
    let daysOfWeekAbb = '';
    resource.days_of_week.forEach(day => {
        daysOfWeekAbb += moment().weekday(day).format('dd') + ' ';
    });

    return {
        id: resource.id,
        name: resource.name,
        placeOriginId: resource.place_origin.id,
        placeOriginName: resource.place_origin.name,
        std: resource.std,
        placeDestinationId: resource.place_destination.id,
        placeDestinationName: resource.place_destination.name,
        sta: resource.sta,
        staAddDays: resource.sta_add_days,
        staAbb: staAbb,
        trucksAbb: trucksAbb,
        truckIds: resource.trucks.map(truck => truck.id),
        daysOfWeekAbb: daysOfWeekAbb,
        daysOfWeek: resource.days_of_week,
        contractorId: resource.contractor ? resource.contractor.id : null,
        contractorName: resource.contractor ? resource.contractor.name : null,
    };
}